import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import Seo from '../components/Seo';

const PrivacyPolicy = () => {
  return (
    <>
      <Seo title="Privacy Policy" description="MoodCraft privacy policy and data handling practices." canonicalPath="/privacy-policy" />
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Lato", sans-serif' }}>
            Privacy Policy
          </Typography>
          <Divider sx={{ mb: 4 }} />
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            1. Introduction
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            Welcome to MoodCraft. We respect your privacy and are committed to protecting your personal data...
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            2. The Data We Collect
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            We collect several types of information from and about users of our website, including information about your mood entries, journal entries, usage patterns, and account details. We use this information to provide personalized mental health support and improve our services.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            3. How We Use Your Data
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            We use your personal data to provide and improve our services, communicate with you, and comply with legal obligations. Your mood tracking data is used to provide personalized insights and recommendations for your mental wellbeing.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            We have implemented appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way. We limit access to your personal data to those employees and third parties who have a business need to know.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            5. Your Legal Rights
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, or to object to processing.
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4, fontFamily: '"Lato", sans-serif' }}>
            6. Contact Us
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: '"Quicksand", sans-serif' }}>
            If you have any questions about this privacy policy or our privacy practices, please contact us through our Contact Us page or by email to Support team (support@moodcraft.org).
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: '"Quicksand", sans-serif' }}>
              Last updated: {new Date().toLocaleDateString()}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
